import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import { Form, Button, Alert, Spinner } from "react-bootstrap";
import employeeData from "../../../store/jsondata/employeData.json";
import AlertModal from "../../../components/UiComponent/AlertModal";
import {
  get_empDetail_dropDown_data,
  updateEmployeeData,
} from "../../../services/employeeApi";

import { GetUserInfo, hasAccess } from "../../../utils/permissionChecker";
const EmplpoyeeUpdateForm = ({ selectedEmployee, onSubmitButton }) => {
  const { t } = useTranslation();
  const user = GetUserInfo();
  const currentUser =
    user.employee.first_name + " " + user.employee.father_name;
  const queryClient = useQueryClient();
  const UpdateEmmployeeMutation = useMutation(async (newData) => {
    await updateEmployeeData(newData);
    queryClient.invalidateQueries("employeeview");
  });
  const [formerror, setFormError] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [showAlert, setshowAlert] = useState();
  const handleClose = () => setshowAlert(false);
  const [AlertMessage, setAlertMessage] = useState("");
  const [alertTitle, setalertTitle] = useState("");
  const changeReasons = [
    { id: 1, name: "Active" },
    { id: 0, name: "Not active" },
  ];
  const [formData, setFormData] = useState({
    id: selectedEmployee.id,
    branch_id: selectedEmployee.branch_id,
    phone: selectedEmployee.phone,
    secondary_phone: selectedEmployee.secondary_phone,
    status: selectedEmployee.status ? 1 : 0,
    updated_by: currentUser,
  });

  const { data, isLoading, isError, error } = useQuery(
    ["employeeRegistration"],
    async () => {
      try {
        const dropDownData = await get_empDetail_dropDown_data();
        return { dropDownData };
      } catch (error) {
        throw new Error(`Error fetching data: ${error.message}`);
      }
    }
  );
  if (isLoading) {
    return <div>Loading...</div>;
  }
  if (isError) {
    return <div>Error: {error.message}</div>;
  }
  const { dropDownData } = data;
  const handleUpdateEmployee = async (employeeData) => {
    try {
      setIsSubmitting(true);
      await UpdateEmmployeeMutation.mutateAsync(employeeData);
      setalertTitle("Success");
      setAlertMessage("Update successful");
      handleCloseModal();
    } catch (error) {
      setalertTitle("Error");
      setAlertMessage(error.message);
    } finally {
      setIsSubmitting(false);
      setshowAlert(true);
    }
  };
  const handleSubmit = (e) => {
    e.preventDefault();
    const requiredFields = ["id", "status", "phone", "branch_id"];
    const isEmptyField = requiredFields.some((field) => !formData[field]);
    if (isEmptyField) {
      setFormError(true);
      return;
    }
    handleUpdateEmployee(formData);
  };
  const handleCloseModal = () => {
    onSubmitButton();
  };

  const handleInputChange = (e, fieldName) => {
    const { value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [fieldName]: value,
    }));
  };

  return (
    <>
      <Form onSubmit={handleSubmit}>
        {formerror ? (
          <Alert variant="danger">
            <p>Please tray again all fields are required.</p>{" "}
          </Alert>
        ) : (
          ""
        )}
        <Form.Group>
          <Form.Label
            htmlFor="inputPosition"
            className="font-weight-bold text-muted"
          >
            {t("branch")}
          </Form.Label>
          <select
            id="inputPosition"
            className="form-select form-control choicesjs"
            value={formData.branch_id}
            onChange={(e) => handleInputChange(e, "branch_id")}
          >
            <option value="" hidden disabled>
              Select Branch
            </option>
            {dropDownData.Branch.map((data) => (
              <option key={data.id} value={data.id}>
                {data.name}
              </option>
            ))}
          </select>
        </Form.Group>
        <Form.Group>
          <Form.Label
            htmlFor="inputPosition"
            className="font-weight-bold text-muted"
          >
            {t("phone")}
          </Form.Label>
          <Form.Control
            type="text"
            placeholder="Enter primary phone"
            value={formData.phone}
            onChange={(e) => handleInputChange(e, "phone")}
          />
        </Form.Group>

        <Form.Group>
          <Form.Label
            htmlFor="inputPosition"
            className="font-weight-bold text-muted"
          >
            {t("phone 2")}
          </Form.Label>
          <Form.Control
            type="text"
            placeholder="Enter secondary phone"
            value={formData.secondary_phone}
            onChange={(e) => handleInputChange(e, "secondary_phone")}
          />
        </Form.Group>
        <Form.Group>
          <Form.Label
            htmlFor="inputReason"
            className="font-weight-bold text-muted"
          >
            {t("status")}
          </Form.Label>
          <select
            id="inputReason"
            className="form-select form-control choicesjs"
            value={formData.status}
            onChange={(e) => handleInputChange(e, "status")}
          >
            <option value="" hidden disabled>
              Select status
            </option>
            {changeReasons.map((data) => (
              <option key={data.id} value={data.id}>
                {t(data.name)}
              </option>
            ))}
          </select>
        </Form.Group>
        <div className="d-flex mt-1">
          <div className="mb-1">
            <Button className="btn btn-secondary" onClick={handleCloseModal}>
              {t("cancel")}
            </Button>
          </div>
          <div className="col-md-6 mb-1">
            <Button
              className="btn btn-info"
              type="submit"
              disabled={isSubmitting}
            >
              {isSubmitting ? (
                <span>
                  <Spinner
                    as="span"
                    animation="grow"
                    size="sm"
                    role="status"
                    aria-hidden="true"
                  />
                  <span className="visually-hidden">Sending...</span>
                </span>
              ) : (
                t("update")
              )}
            </Button>
          </div>
        </div>
      </Form>

      <AlertModal
        show={showAlert}
        onHide={handleClose}
        title={alertTitle}
        message={AlertMessage}
      />
    </>
  );
};

export default EmplpoyeeUpdateForm;
